import { render, staticRenderFns } from "./TrainingDevelopment.vue?vue&type=template&id=1becb1b5&scoped=true&"
import script from "./TrainingDevelopment.vue?vue&type=script&lang=js&"
export * from "./TrainingDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDevelopment.vue?vue&type=style&index=0&id=1becb1b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1becb1b5",
  null
  
)

export default component.exports